import React from "react";
import{Link} from 'react-router-dom'
import "./Home.css"
// import About from "./About"
// import GetStarted from "./GetStarted"
import homepic1 from "../imgs/homepic1.jpg"
import homepic2 from "../imgs/homepic2.jpg"
import homepic3 from "../imgs/homepic3.jpg"
import aeroneerh1 from "../imgs/AEROneer.png"

const Home=()=>{
	return(
			
			<div>
			<div className="AboutUs">
				<img src={aeroneerh1} alt="aeroneer" className="aeroneerh1"/>
				<img src={homepic1} alt="homepic1" className="homepic1"/>
				<Link to="/getstarted"><button className="btn1">Start Learning</button></Link>
				</div>

				<div className="GetStarted">
				<img src={homepic2} alt="homepic2" className="homepic2"/>
				<h1>Know more about us</h1>
				<Link to="/about"><button className="btn2">About us</button></Link>
				</div>
				
				<div className="xyz">
				<img src={homepic3} alt="homepic2" className="homepic3"/>
				</div>
				
				

				
	        
			</div>
		);
}

export default Home;




